import QuantityProduct from './QuantityProduct'

class EveningPhotoProduct extends QuantityProduct {
  static MINIMUM_QUANTITY = 5
}

export default EveningPhotoProduct
